import React, { memo } from 'react';

import './styles/index.scss';
import './App.scss';
import RootNavigator from './navigation/RootNavigator';

const App = () => <RootNavigator />;

export default memo( App );
